import { AfterViewInit, OnDestroy, Directive, Injectable, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { MapComponent } from '@realpage-da/ng-map';

import { EntityBase } from '~/core/model';
import { SelectableGridBaseComponent } from './grid-base.component';

@Injectable()
export abstract class MapGridComponent<TGrid extends SelectableGridBaseComponent = SelectableGridBaseComponent> implements AfterViewInit, OnDestroy {
  map: MapComponent;
  @ViewChild('grid') grid: TGrid;

  protected destroy: Subject<boolean> = new Subject();
  onDestroy: Observable<boolean> = this.destroy.filter(f => !!f);

  abstract select(id: number);

  ngAfterViewInit() {
    this.map.onMarkerSelected
      .takeUntil(this.onDestroy)
      .subscribe(selection => {
        this.map.map.addTooltip(selection.marker);
        this.grid.selectRow(selection.marker.id);
      });

    this.map.onPolygonSelected
      .takeUntil(this.onDestroy)
      .subscribe(polygon => {
        this.map.map.addTooltip(polygon);
        this.grid.selectRow(polygon.id);
      });

    this.grid.grid.cellClicked
      .takeUntil(this.onDestroy)
      .subscribe(cell => this.map.map.addTooltip(this.map.map.findFeature(cell.data.data.id)));
  }

  ngOnDestroy() {
    this.destroy.next(true);
    this.destroy.complete();


    this.map.map.setPolygons([]);
    this.map.map.setMarkers([]);
    this.map.map.removeTooltip();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/grids/map-grid.component.ts